import { type CustomField, getItemFields, type ItemFieldEntry, type ItemType } from '@cheqroom/api';
import { useMemo } from 'react';

interface UseItemFieldDefinitionsProps {
	itemTypeId?: string;
	itemTypes?: ItemType[];
	hasDepreciationPermission?: boolean;
	customFields?: CustomField[];
	currency?: string | null;
}

export const useItemFieldDefinitions = ({
	itemTypeId,
	itemTypes,
	hasDepreciationPermission,
	customFields,
	currency,
}: UseItemFieldDefinitionsProps): ItemFieldEntry[] => {
	const systemFieldsVisibility = useMemo(
		() => itemTypes?.find((itemType) => itemType.id === itemTypeId)?.system_fields_visibility,
		[itemTypes, itemTypeId]
	);

	return useMemo(
		() => getItemFields({ systemFieldsVisibility, hasDepreciationPermission, customFields, currency }),
		[systemFieldsVisibility, hasDepreciationPermission, customFields, currency]
	);
};
